import styled from 'styled-components';
import { Pill as DsnyPill } from '@dsny/dsny-component-library';
import { device, mtrStyle } from 'src/styles/global';
import theme from 'src/styles/theme';
import { SkeletonBlock as BaseSkeletonBlock } from '../Dashboard/Dashboard.styles';

export const LibraryWrapper = styled.div`
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
  padding: 0px 24px 0px;

  @media ${device.mobile} {
    padding: 90px 16px 0px;
  }

  @media ${device.tablet} {
    padding: 0px 16px 0px;
  }

  @media ${device.ipad} {
    padding: 0px 16px 0px;
  }

  @media ${device.laptop} {
    padding: 0px 24px 0px;
  }

  @media ${device.desktop} {
    padding: 0px 24px 0px;
  }
`;

export const LibraryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 100%;
  max-width: 1286px; /* Library max-width */
  padding-bottom: 48px;

  @media ${device.mobile} {
    padding-bottom: 0px;
  }
`;

export const BannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 24px;
  padding-top: 2px;

  @media ${device.mobile} {
    padding-bottom: 16px;
  }
`;

export const LibraryBox = styled.div`
  display: flex;
  flex-direction: column;
  position: inherit;
  border-radius: ${mtrStyle.borderRadius};
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
  background-color: ${theme.colors.white0};
`;

export const TableBoxDesktop = styled.div`
  display: flex;
  height: 540px;

  @media ${device.mobile} {
    display: none;
  }
`;

export const TableBoxMobile = styled.div`
  display: none;

  @media ${device.mobile} {
    display: flex;
    height: 540px;
  }
`;

export const DashboardHeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;

  @media ${device.mobile} {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  @media ${device.tablet} {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const InsightsMobileWrapper = styled.div`
  padding-bottom: 8px;
`;

export const DashboardHeading = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: ${theme.colors.neutralW20};
`;

export const DashboardHeadingSkeleton = styled(BaseSkeletonBlock)`
  width: 220px;
  height: 36px;

  @media ${device.mobile} {
    width: 56%;
    height: 28px;
  }
`;

export const InsightWelcomeMessage = styled.div`
  font-size: 14px;
  color: ${theme.colors.neutralW40};
  margin-bottom: -12px;
`;

export const LibrarydHeadingWrapper = styled.div`
  padding: 32px 32px 32px;

  @media ${device.mobile} {
    padding: 24px 24px 24px;
    font-size: 24px;
  }
`;

export const LibrarydHeading = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.neutralW20};
  margin-bottom: 8px;

  @media ${device.mobile} {
    font-size: 20px;
  }
`;

export const LibraryHeaderSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LibraryHeadingSkeleton = styled(BaseSkeletonBlock)`
  width: 108px;
  height: 28px;
  margin-bottom: 8px;

  @media ${device.mobile} {
    width: 96px;
    height: 24px;
  }
`;

export const LibraryDescriptionSkeleton = styled(BaseSkeletonBlock)`
  width: 420px;
  height: 16px;

  @media ${device.mobile} {
    width: 100%;
    max-width: 280px;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding-top: 24px;

  @media ${device.mobile} {
    padding-top: 16px;
    flex-direction: column;
  }
`;

export const SearchInputSkeleton = styled(BaseSkeletonBlock)`
  width: 336px;
  height: 44px;
  border-radius: 5px;

  @media ${device.mobile} {
    width: 100%;
  }
`;

export const ActionBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 85px;
  padding: 24px;
  z-index: 998;
  background: ${theme.colors.white0};
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.25);
`;

export const FilterByWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  color: ${theme.colors.neutralW40};
  gap: 8px;

  @media ${device.mobile} {
    justify-content: flex-start;
    align-self: flex-start;
    width: 100%;
  }
`;

export const StyledPill = styled(DsnyPill)`
  color: ${theme.colors.mtr60};
  border: 1px solid #7d7fe8;
  background: ${theme.colors.mtr100};

  &:focus-visible {
    outline: 1px solid #7d7fe8;
  }

  &:hover {
    background: ${theme.colors.mtr100};
  }
`;
